import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React from "react"

import BackgroundLogo from "./deco/BackgroundLogo"

function Item({ item, backgroundColor }) {
  return (
    <div className="flex flex-col overflow-hidden">
      <div
        className={`${
          backgroundColor === "blue" ? "bg-white" : "bg-charlestonGreen-100"
        } flow-root px-6 pt-6 pb-6  grow`}
      >
        <div className>
          {item?.iconMedia?.localFile?.childImageSharp?.gatsbyImageData && (
            <span className="flex items-center justify-center">
              <GatsbyImage
                objectFit="contain"
                className={item?.big ? "w-56 h-24" : "w-12"}
                alt={item.iconMedia?.altText}
                image={
                  item?.iconMedia?.localFile?.childImageSharp?.gatsbyImageData
                }
              />
            </span>
          )}
          {item.title && (
            <h3 className="mt-8 text-2xl font-extrabold tracking-tight text-gray-900">
              {item.title}
            </h3>
          )}
          {item.content && (
            <p className="mt-2 text-lg font-regular">
              {HTMLReactParser(item.content)}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default function Hero({ component }) {
  const {
    items,
    backgroundColor,
    withDecoration,
    title,
    subtitle,
    iconMedia,
  } = component

  return (
    <div
      className={`relative ${
        backgroundColor === "blue" ? "bg-charlestonGreen-100" : ""
      } 
      ${withDecoration ? "overflow-hidden" : ""} 
      pt-2 sm:pt-6 lg:pt-12 pb-8 sm:pb-16 lg:pb-24`}
    >
      {withDecoration && (
        <div className="absolute right-2/3 absolute right-0 top-1/2 -translate-y-1/2">
          <BackgroundLogo />
        </div>
      )}
      {(iconMedia?.localFile || title || subtitle) && (
        <div className="space-y-12 mb-4">
          <div className="space-y-5 text-center sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
            {iconMedia?.localFile?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                className="w-8 h-8 "
                image={iconMedia?.localFile?.childImageSharp?.gatsbyImageData}
                alt={iconMedia?.altText}
              />
            )}
            {title && (
              <h2 className="text-3xl lg:text-4xl font-bold">{title}</h2>
            )}
            {subtitle && (
              <p className="text-xl text-charlestonGreen-500">
                {HTMLReactParser(subtitle)}
              </p>
            )}
          </div>
        </div>
      )}
      <div className="relative max-w-md px-4 mx-auto sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3 justify-center">
          {items.map(item => (
            <Item
              key={item.title}
              item={item}
              backgroundColor={backgroundColor}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
